import React from "react";

import {
  getInitials,
  getCoverageMatrixDotColor,
  resolveExecSponsorBadgeType,
  resolveVendorJobTitle,
} from "./relationshipUtils";
import { ExecTeamPsLegend } from "./vendor-team-matrix-ui";
import { getVendorProfileAvatarBg } from "../../../Utils/Helper/profileAvatarUi";

export function BuddyMatrixSponsorBadge({ sponsorType }) {
  if (sponsorType === "primary") {
    return (
      <span className="sponsor-badge primary" title="Primary sponsor">
        P
      </span>
    );
  }
  if (sponsorType === "secondary") {
    return (
      <span className="sponsor-badge secondary" title="Secondary sponsor">
        S
      </span>
    );
  }
  return null;
}

export function BuddyMatrixVendorRowLabel({ vendor }) {
  const isTeam = vendor.__vendorType === "account_team_member";
  const displayName = vendor.member_name || vendor.name || "Vendor";
  const subtitle = isTeam
    ? String(vendor.member_title || vendor.title || "").trim()
    : resolveVendorJobTitle(vendor) ||
      vendor.title ||
      vendor.roleLabel ||
      "Executive";
  const sponsorBadge = !isTeam ? resolveExecSponsorBadgeType(vendor) : null;

  return (
    <div className="buddy-row-hdr">
      <div
        className="at-avatar"
        style={{
          background: getVendorProfileAvatarBg(isTeam),
          width: 24,
          height: 24,
          fontSize: 9,
        }}
      >
        {getInitials(displayName)}
      </div>
      <div className="min-w-0">
        <div className="buddy-row-name">
          {displayName}
          {sponsorBadge ? (
            <BuddyMatrixSponsorBadge sponsorType={sponsorBadge} />
          ) : null}
        </div>
        <div className="buddy-row-sub">{subtitle}</div>
      </div>
    </div>
  );
}

export function BuddyMatrixSectionHeader({
  icon: Icon,
  label,
  count,
  colSpan,
  showPsLegend = false,
}) {
  return (
    <tr className="section-hdr">
      <td colSpan={colSpan} className="rh">
        <div className="flex items-center gap-2 text-[10.5px] font-bold uppercase tracking-wide text-gray-600">
          <Icon size={14} className="shrink-0 text-purple-600" />
          {label}
          <span className="font-medium normal-case tracking-normal text-gray-500">
            ({count})
          </span>
          {showPsLegend ? <ExecTeamPsLegend /> : null}
        </div>
      </td>
    </tr>
  );
}

export function BuddyMatrixCell({ checked, canEdit, onToggle, rl }) {
  const dotTitle =
    rl === null || rl === undefined ? "Mapped — not assessed" : `RL ${rl}`;

  return (
    <td className="buddy-cell-td">
      <div className={`buddy-cell${checked ? " is-checked" : ""}`}>
        <input
          type="checkbox"
          className="buddy-check"
          checked={checked}
          disabled={!canEdit}
          onChange={onToggle}
          aria-label={checked ? "Mapped" : "Unmapped"}
        />
        {checked ? (
          <span
            className="buddy-rl-dot"
            style={{ background: getCoverageMatrixDotColor(rl) }}
            title={dotTitle}
            aria-hidden
          />
        ) : null}
      </div>
    </td>
  );
}
